// extracted by mini-css-extract-plugin
module.exports = {"FloorCheck":"FloorCheck_FloorCheck__16EsL","Title":"FloorCheck_Title__50Z_l","Img":"FloorCheck_Img__jlh6P","Btn":"FloorCheck_Btn__1oYa2"};